import Logo_DarkMode from "../assets/Logo_DarkMode.png";
import Logo_Default from "../assets/Logo_Default.png";

export default {
  APPLICATION: {
    NAME: process.env.VUE_APP_NAME || "Application name",
    LOGO: Logo_Default,
    LOGO_DARK_MODE: Logo_DarkMode,
    LOCALE:
      process.env.VUE_APP_I18N_LOCALE ||
      process.env.VUE_APP_I18N_FALLBACK_LOCALE ||
      "en",
    VIEW_COMPONENTS: [
      // { name: "Welcome" },
      // { name: "Services" },
      { name: "About" },

      { name: "Github" },
      { name: "Contact" },

      // { name: "RecentProjects" },
    ],
    API_STATE: {
      INIT: 0,
      LOADING: 1,
      ERROR: 2,
      LOADED: 3,
    },
    GET_APP_NAME() {
      return this.NAME.toUpperCase();
    },
  },
  COPYRIGHTS: {
    OWNER: process.env.VUE_APP_OWNER || "Copyrights Owner",
    YEAR: new Date().getFullYear(),
    GET_COPYRIGHTS() {
      return (
        this.OWNER.toString() +
        " \u00A9 " +
        this.YEAR.toString() +
        " "
      );
    },
  },
  BACKEND: {
    url: process.env.VUE_APP_BACKEND_URL || "http://localhost:4545/api/v1/",
  },
  GITHUB: {
    user: process.env.VUE_APP_GITHUB_USER || "",
    repos: process.env.VUE_APP_GITHUB_REPOS.split(",") || [],
    projects: [],
    GET_API_REPO_URL(repo) {
      if (this.user !== "" && repo.length !== 0) {
        return "https://api.github.com/repos/" + this.user + "/" + repo;
      } else {
        return null;
      }
    },
    GET_API_COMMITS_URL(repo) {
      if (this.user !== "" && repo.length !== 0) {
        let url = this.GET_API_REPO_URL(repo) + "/commits";
        return url;
      } else {
        return null;
      }
    },
    GET_USER_URL() {
      if (this.user !== "empty") {
        let url = "https://github.com/" + this.user;
        return url;
      } else {
        return null;
      }
    },
    GET_REPO_URL(repo) {
      if (repo.length !== 0) {
        let url = this.GET_USER_URL() + "/" + repo;
        return url;
      } else {
        return null;
      }
    },
  },
  UTILS: {
    hexToRgb(hex) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + ",1)"
        );
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
